export var StepToIndex = {
    DirectoryDetail: 0,
    DomainSelection: 1,
    MapAttribute: 2,
    GroupSelection: 3,
    UserSelection: 4,
    Preview: 5
};
